<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Transaction Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Transaction Type" label-position="inside">
                        <b-select expanded v-model="transaction.type">
                            <option>Automatic Payment</option>

                            <option value="admin_plan_installment">Admin Plan Installment</option>
                            <option value="auto_plan_installment">Automatic Plan Installment</option>
                            <option value="plan_installment">Additional Payment</option>
                            <option value="check">Check</option>
                            <option value="fee">Fee</option>
                            <option value="interest">Interest</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-8">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="transaction.title" :placeholder="placeholder"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field :label="label" label-position="inside">
                        <b-input v-model="transaction.total" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">

            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Payment Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-right" append-to-body v-model="transaction.created_at"></b-datetimepicker>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Completed Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-left" append-to-body v-model="transaction.completed_at"></b-datetimepicker>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <div class="p-4 is-size-7"><i class="fal fa-exclamation-circle mr-2"></i>Note: This doesn't actually 'charge' the plan, it's just for adjusting things manually.</div>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'PlanTransactionForm',
        props: {
            transaction: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {
            placeholder() {
                if (this.type === 'fee' || this.type === 'interest') {
                    return 'Interest Fee, Late Fee, NSF/Non-Payment Fee, etc.';
                } else {
                    return 'Check, Additional Payment, Manual Payment, etc.';
                }
            },
            label() {
                if (this.type === 'fee' || this.type === 'interest') {
                    return 'Fee Amount';
                } else {
                    return 'Payment Amount';
                }
            }
        },
        methods: {

        },
        mounted: function() {

        }
    };
</script>
